// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import $ from "jquery";
import App from "./App";

import "babel-polyfill";
import router from "./router";
import store from "./store";
import "./permission";
import dotdotdot from "dotdotdot";
import VueI18n from "vue-i18n"; //引入vue-i18n
import "../static/iconfont/iconfont.css";
import {
  Search,
  Picker,
  Switch,
  Tab,
  Tabs,
  Notify,
  Toast,
  Checkbox,
  NavBar,
  DropdownMenu,
  DropdownItem,
  List,
  Image as VanImage,
  SwipeCell,
  Button,
  Dialog,
  DatetimePicker,
  Popup,
  Uploader,
  Overlay,
  Loading,
  Swipe,
  SwipeItem,
  Field,
  Pagination,
  Icon
} from "vant";
import { Select, Option, Input } from "element-ui";
import weui from "jquery-weui/dist/js/jquery-weui.min";
import picker from "jquery-weui/dist/js/city-picker.min";
import swiper from "jquery-weui/dist/js/swiper.min";
import "jquery-weui/dist/css/jquery-weui.min.css";
import "jquery-weui/dist/lib/weui.min.css";

// import VeBar from 'v-charts/lib/bar.common'
// import VeLine from 'v-charts/lib/line.common'

// Vue.component('bar-chart',VeBar)
// Vue.component('line-chart',VeLine)
import echarts from "echarts";

Vue.config.productionTip = false;
Vue.use(Picker)
  .use(Switch)
  .use(Tab)
  .use(Tabs)
  .use(Notify)
  .use(Toast)
  .use(Checkbox)
  .use(NavBar)
  .use(NavBar)
  .use(DropdownMenu)
  .use(DropdownItem)
  .use(List)
  .use(VanImage)
  .use(SwipeCell)
  .use(Button)
  .use(Select)
  .use(Option)
  .use(DatetimePicker)
  .use(Popup)
  .use(Dialog)
  .use(Uploader)
  .use(Icon)
  .use(Overlay)
  .use(Loading)
  .use(Swipe)
  .use(SwipeItem)
  .use(Field)
  .use(Input)
  .use(Pagination)
  .use(Dialog)
  .use(Search);
Vue.prototype.$echarts = echarts;
Vue.prototype.$dialog = Dialog;
Vue.use(VueI18n); //通过插件的形式挂载

const i18n = new VueI18n({
  locale: "zh", // 语言标识
  silentFallbackWarn: true,
  messages: {
    zh: Object.assign(require("@/components/lang/zh")), //这里需要注意一下，是如何导入多个语言包的
    en: Object.assign(require("@/components/lang/en"))
  }
});

let HOST = process.env.HOST;
let url = "";
switch (HOST) {
  case "dev":
    url = "http://weixiao.ct-study.com.cn";
    break;
  case "prod":
    url = "https://feedback.sjtu.edu.cn";
    break;
  case "test":
    url = "http://weixiao.ct-study.com.cn";
    break;
}

Vue.prototype.$pcHtml = url;
window.$pcHtml = Vue.prototype.$pcHtml;
// Vue.prototype.$pcHtml = 'http://192.168.100.12'

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  i18n,
  components: { App },
  template: "<App/>"
});

// WEBPACK FOOTER //
// ./src/main.js



// WEBPACK FOOTER //
// ./src/main.js